import { useQuery } from '@apollo/client'
import { CatalogFileViewerDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import { FileViewer, File as FileViewerFile } from 'modules/trainings/components/Files/FileViewer'

interface TrainingFile extends FileViewerFile {}

export default function CatalogFileViewer() {
  const { trainingId, fileId, fileType } = useStrictParams<'trainingId' | 'fileId' | 'fileType'>()
  const { navigation } = useNavigation()

  const { data, loading, error } = useQuery(CatalogFileViewerDocument, {
    variables: {
      trainingId: Number(trainingId),
    },
  })

  if (loading) return null
  if (error) throw error

  const trainingFiles = data?.trainings?.trainingFilesConnection?.nodes || []
  const trainingClassFiles = data?.trainings?.trainingClassFilesConnection?.nodes || []

  const files: TrainingFile[] = []
  for (const file of trainingFiles) {
    files.push({
      id: file.id,
      filename: file.filename,
      contentType: file.contentType,
      url: file.url,
      type: 'training' as const,
    })
  }
  for (const file of trainingClassFiles) {
    files.push({
      id: file.id,
      filename: file.filename,
      contentType: file.contentType,
      url: file.url,
      type: 'trainingClass' as const,
    })
  }

  const currentFile = files.find((f) => f.id === Number(fileId) && f.type === fileType)
  if (!currentFile) {
    throw new Error(`File with ID ${fileId} not found in training ${trainingId}.`)
  }

  return (
    <FileViewer
      file={currentFile}
      files={files}
      urlBackTo={navigation.trainings.catalog.detail.materials.fullPath({
        trainingId: trainingId || '',
      })}
      goNextFile={(prevFileInViewer: TrainingFile): string => {
        if (prevFileInViewer && prevFileInViewer.id) {
          return navigation.trainings.catalog.detail.materials.previewFile.fullPath({
            trainingId: trainingId || '',
            fileId: String(prevFileInViewer.id),
            fileType: prevFileInViewer.type,
          })
        }
        return '#'
      }}
      goPrevFile={(nextFileInViewer: TrainingFile): string => {
        if (nextFileInViewer && nextFileInViewer.id) {
          return navigation.trainings.catalog.detail.materials.previewFile.fullPath({
            trainingId: trainingId || '',
            fileId: String(nextFileInViewer.id),
            fileType: nextFileInViewer.type,
          })
        }
        return '#'
      }}
    />
  )
}
